import { Reveal } from "../components/Reveal";

const VALUES = [
  { title: "Integrity", body: "[Add content here] Every project honors its commitments — timeline, budget, quality." },
  { title: "Diversification", body: "[Add content here] Cross-industry strength stabilizes outcomes for everyone we work with." },
  { title: "Long-term partnership", body: "[Add content here] Relationships that outlast projects — clients, subcontractors, vendors." },
];

export default function About() {
  return (
    <div className="pt-16 md:pt-20" data-testid="page-about">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-32">
        <div className="text-xs uppercase tracking-[0.3em] text-forest font-semibold mb-6">About Stone Shire Group</div>
        <h1 className="text-5xl sm:text-6xl lg:text-8xl font-extrabold text-navy tracking-tighter leading-[0.95] max-w-4xl">
          Built to hold many industries — with one standard.
        </h1>
        <p className="mt-8 text-lg md:text-xl text-slate max-w-2xl leading-relaxed">
          [Add content here] A short introduction to the group&apos;s history, values, and reason for existing across multiple industries.
        </p>
      </section>

      <section className="bg-stone">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32 grid md:grid-cols-2 gap-16">
          <Reveal>
            <div className="text-xs uppercase tracking-[0.3em] text-forest font-semibold mb-4">Mission</div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy tracking-tight leading-tight">
              To deliver reliability across every sector we operate in — one relationship, one project at a time.
            </h2>
          </Reveal>
          <Reveal delay={1}>
            <div className="text-xs uppercase tracking-[0.3em] text-forest font-semibold mb-4">Vision</div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy tracking-tight leading-tight">
              A holding group whose divisions each stand alone — but stand stronger together.
            </h2>
          </Reveal>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="text-xs uppercase tracking-[0.3em] text-forest font-semibold mb-4">Values</div>
        <h2 className="text-3xl md:text-5xl font-bold text-navy tracking-tight mb-14 max-w-3xl">The principles behind every division.</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {VALUES.map((v, i) => (
            <Reveal key={v.title} delay={i}>
              <div className="rounded-2xl border border-stone p-8 h-full bg-white" data-testid={`value-${v.title}`}>
                <div className="text-forest text-sm font-bold uppercase tracking-widest">0{i+1}</div>
                <div className="mt-3 text-2xl font-bold text-navy">{v.title}</div>
                <p className="mt-3 text-slate leading-relaxed">{v.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 pb-24 md:pb-32">
        <div className="grid md:grid-cols-12 gap-10">
          <Reveal className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-forest font-semibold mb-4">Our Team</div>
            <h2 className="text-3xl md:text-5xl font-bold text-navy tracking-tight leading-tight">Leadership</h2>
          </Reveal>
          <Reveal className="md:col-span-8" delay={1}>
            <p className="text-xl md:text-2xl text-navy leading-relaxed max-w-3xl" data-testid="leadership-statement">
              Stone Shire Group is led by a team of experienced professionals across construction, trade, and technology — committed to delivering results with integrity and precision.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-navy text-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] font-semibold mb-4" style={{color:"#8AA795"}}>Why the group model</div>
            <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight leading-tight">Diversification is a strength — not a distraction.</h2>
          </div>
          <div className="md:col-span-7 grid sm:grid-cols-2 gap-8 text-white/80">
            <div>
              <div className="text-xl font-bold text-white">Cross-industry reliability</div>
              <p className="mt-2 leading-relaxed">[Add content here] Multiple divisions mean less concentration risk and more resilient delivery.</p>
            </div>
            <div>
              <div className="text-xl font-bold text-white">A single point of trust</div>
              <p className="mt-2 leading-relaxed">[Add content here] Whether construction, trade or IT — one relationship, one accountable team.</p>
            </div>
            <div>
              <div className="text-xl font-bold text-white">Global network</div>
              <p className="mt-2 leading-relaxed">[Add content here] Partners, subcontractors, suppliers across regions.</p>
            </div>
            <div>
              <div className="text-xl font-bold text-white">Room to grow</div>
              <p className="mt-2 leading-relaxed">[Add content here] New divisions, new sectors — always open to the right partnership.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
